import { StyledSubProduct } from './style';
import { ProductData } from 'utils/types';
import { AutoTextSize } from 'utils/autoTextSizeUtils';
import { Box } from '@mui/material';
import Tooltip from 'components/Tooltip/HugeCasino';
import TooltipComponent from '@mui/material/Tooltip';
import { useTooltip } from 'utils/useTooltip';
import { OfferClassName } from 'utils/enums';

interface SubRollingOfferSubProductProps {
  index: number;
  subProduct: ProductData;
  isHorizontalViewActive: boolean;
}

export const SubRollingOfferSubProduct: React.FC<
  SubRollingOfferSubProductProps
> = ({ index, subProduct, isHorizontalViewActive }) => {
  const {
    textFontColorHex,
    quantityDisplay,
    images,
    quantity,
    name,
    productType,
    rarityProductInfo,
    badgeText,
  } = subProduct;
  const tooltipIcon =
    'https://media.appcharge.com/media/641026dc506b12bf96a88368/tooltip.png';

  const { productRef, handleToggleTooltip } = useTooltip();

  return (
    <StyledSubProduct
      className="sub-product"
      color={textFontColorHex}
      custom={index}
      ref={productRef}
      isHorizontalViewEnabled={isHorizontalViewActive}
      hasBadge={!!badgeText?.length}
    >
      <Box
        className="product-image-container"
        onClick={(e) =>
          handleToggleTooltip(
            e,
            !!rarityProductInfo,
            OfferClassName.ROLLING_OFFER,
          )
        }
      >
        {rarityProductInfo && (
          <TooltipComponent
            className="rarity-tooltip"
            enterTouchDelay={0}
            leaveTouchDelay={1700}
            title={
              <Tooltip
                productName={String(name)}
                quantityDisplay={quantityDisplay}
                productType={productType}
                productAmount={quantity as number}
                tooltipText={rarityProductInfo.tooltipText}
                rarityText={rarityProductInfo.rarityText}
                stars={rarityProductInfo.stars}
                display={true}
                customPositioning={'relative'}
                customStyles={{
                  marginTop: '-20px',
                  whiteSpace: 'normal',
                }}
              />
            }
            placement="bottom-start"
            componentsProps={{
              tooltip: {
                sx: {
                  padding: '12px 6px',
                  background: 'transparent',
                  color: '#000000',
                  fontWeight: 'normal',
                },
              },
            }}
          >
            <img src={tooltipIcon} alt="tooltip" className="tooltip" />
          </TooltipComponent>
        )}
        {badgeText && (
          <Box className="badge">
            <AutoTextSize
              maxFontSizePx={14}
              minFontSizePx={1}
              as="h4"
              className="badge-text"
              mode="oneline"
            >
              {badgeText}
            </AutoTextSize>
          </Box>
        )}
        <div className="sub-product-image">
          {images.product && (
            <img className="product" src={images.product} alt="product" />
          )}
        </div>
      </Box>
      <div className="text">
        <AutoTextSize
          maxFontSizePx={isHorizontalViewActive ? 18 : 14}
          minFontSizePx={isHorizontalViewActive ? 2 : 1}
          as="p"
          className="quantity"
          mode="oneline"
        >
          {quantityDisplay}
        </AutoTextSize>
        {rarityProductInfo && (
          <p className="tooltip">
            {rarityProductInfo.rarityText}{' '}
            {Array.from({ length: rarityProductInfo.stars }, (_, i) => {
              return (
                <img
                  className="tooltip-img"
                  src="https://media.appcharge.com/media/641026dc506b12bf96a88368/star.png"
                  alt="star"
                  key={i}
                />
              );
            })}
          </p>
        )}
      </div>
    </StyledSubProduct>
  );
};
